<template>
  <m-dialog
    v-model="isDialogOpen"
    class="form-dialog"
    v-bind="$attrs"
    v-on="$listeners">
    <div
      v-if="header"
      slot="header"
      :level="1">
      {{ header }}
    </div>
    <div
      slot="body"
      :level="1">
      <slot name="body" />
    </div>
    <m-button
      v-if="ok"
      slot="acceptButton"
      :disabled="!allowOkay"
      class="mdc-dialog__button accept-button"
      data-mdc-dialog-action="OK">
      {{ ok }}
    </m-button>
    <m-button
      v-if="cancel"
      slot="cancelButton"
      class="mdc-dialog__button"
      data-mdc-dialog-action="Cancel">
      {{ cancel }}
    </m-button>
  </m-dialog>
</template>
<script>

import Vue from 'vue'
import MButton from 'material-components-vue/dist/button'
import Dialog from 'material-components-vue/dist/dialog'
Vue.use(MButton)
Vue.use(Dialog)

export default {
  props: {
    allowOkay: {
      default: true,
      required: false,
      type: Boolean
    },
    cancel: {
      default: '',
      required: false,
      type: String
    },
    header: {
      default: '',
      required: false,
      type: String
    },
    ok: {
      default: '',
      required: false,
      type: String
    },
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      isDialogOpen: this.value
    }
  },
  watch: {
    value () {
      this.isDialogOpen = this.value
    }
  }
}
</script>
<style lang="scss">
  @import '../../universal/vars.scss';
  @import "material-components-vue/dist/dialog/styles";

.mdc-dialog {
  z-index: 30;
}
.form-dialog .mdc-dialog__content {
  padding-bottom: 0;
}
.form-dialog .mdc-dialog__content, .mdc-dialog__surface {
  overflow: visible;
}
.form-dialog .mdc-dialog__title {
  margin-top: -28px;
  margin-bottom: 16px;
}
.form-dialog .mdc-dialog__surface {
  width: 480px;
}
.form-dialog .mdc-button:not(:disabled) {
  color: $mdc-theme-primary--500;
}
.form-dialog .mdc-button:not(:disabled).accept-button {
  background-color: $mdc-theme-primary--500;
  color: white;
}
.form-dialog .mdc-button {
  text-transform: none;
}
.form-dialog .mdc-dialog__actions {
  padding-right: 16px;
  padding-bottom: 16px;
}
.form-dialog .mdc-button:not(.mdc-ripple-upgraded):focus::before {
  opacity: 0;
}
.form-dialog .mdc-button.mdc-ripple-upgraded--background-focused::before {
  opacity: 0;
}
.form-dialog .mdc-button.mdc-ripple-upgraded--background-focused:hover {
  background-color: rgb(241, 248, 249);
}
</style>
